import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { useTranslations } from '../utils/translationDictionaries';
import './Resources.css';

const Resources = () => {
  const { language } = useLanguage();
  const { t } = useTranslations(language);

  const resources = [
    {
      id: 1,
      title: t('Comparables Online'),
      image: 'https://firebasestorage.googleapis.com/v0/b/realty-website-764ee.firebasestorage.app/o/web-media%2Fcomparablesonl.png?alt=media&token=f5b1d730-e8f8-4e65-a0d6-98665c5d0267',
      link: 'https://puertoricoe.com/',
    },
    {
      id: 2,
      title: t('CRIM PR'),
      image: 'https://firebasestorage.googleapis.com/v0/b/realty-website-764ee.firebasestorage.app/o/web-media%2Fcrim.png?alt=media&token=6fa0cfaf-d9a7-4541-ac99-a0cb3138ed80',
      link: 'https://catastro.crimpr.net/cdprpc/',
    },
    {
      id: 3,
      title: t('Mapa Interactivo de Puerto Rico - Junta de Planificaciones'),
      image: 'https://firebasestorage.googleapis.com/v0/b/realty-website-764ee.firebasestorage.app/o/web-media%2Fjuntaplanificacion.png?alt=media&token=c7db6c10-7d30-452e-95e1-02db1cdc9ad4',
      link: 'https://gis.jp.pr.gov/mipr/',
    },
    {
      id: 4,
      title: t('Registro Inmobiliario Digital de Puerto Rico'),
      image: 'https://firebasestorage.googleapis.com/v0/b/realty-website-764ee.firebasestorage.app/o/web-media%2Fkaribe.png?alt=media&token=7ec6e3b0-096c-44d4-b51a-0f66481abaf5',
      link: 'https://karibe.ridpr.pr.gov/client/#login',
    },
    {
      id: 5,
      title: t('Poder Judicial de Puerto Rico'),
      image: 'https://firebasestorage.googleapis.com/v0/b/realty-website-764ee.firebasestorage.app/o/web-media%2Fpoderjudicial.png?alt=media&token=f9a78762-e407-461a-a35f-f73419516d71',
      link: 'https://poderjudicial.pr/educacion-a-la-comunidad/informacion-sobres-temas-legales/derechos-y-deberes/participacion-ciudadana/',
    },
    {
      id: 6,
      title: t('Departamento de Justicia de Puerto Rico'),
      image: 'https://firebasestorage.googleapis.com/v0/b/realty-website-764ee.firebasestorage.app/o/web-media%2Fjusticia.png?alt=media&token=d13d507f-949e-432b-8abd-61b0eb200760',
      link: 'https://www.justicia.pr.gov/',
    },
    {
      id: 8,
      title: t('Registro de la Propiedad de Puerto Rico'),
      image: 'https://firebasestorage.googleapis.com/v0/b/realty-website-764ee.firebasestorage.app/o/web-media%2Fjusticia.png?alt=media&token=d13d507f-949e-432b-8abd-61b0eb200760',
      link: 'http://ridpr.pr.gov/',
    },
    {
      id: 9,
      title: t('Vivienda Pública de Puerto Rico'),
      image: 'https://firebasestorage.googleapis.com/v0/b/realty-website-764ee.firebasestorage.app/o/web-media%2Fviviendapublica.png?alt=media&token=6f65ac80-d1b8-4a12-be05-16a93faa0b2a',
      link: 'https://www.avp.pr.gov/nuestros-residenciales',
    },
    {
      id: 10,
      title: t('FEMA - Mapa de Riesgo de Inundaciones'),
      image: 'https://firebasestorage.googleapis.com/v0/b/realty-website-764ee.firebasestorage.app/o/web-media%2Ffema.png?alt=media&token=4d17cd37-14a9-4fef-bacb-a9566ee6fe30',
      link: 'https://msc.fema.gov/portal/home',
    },
    {
      id: 11,
      title: t('Boricua Online'),
      image: 'https://firebasestorage.googleapis.com/v0/b/realty-website-764ee.firebasestorage.app/o/web-media%2Fboricuaonline.jpg?alt=media&token=e9684b99-b111-4039-86e4-8c6e47ede14c',
      link: 'https://boricuaonline.com/',
    }
  ];

  return (
    <div className="resources">

      <section className="resources-hero">
        <div className="resources-hero-content">
          <h1>{t('resources.title')}</h1>
          <p>{t('resources.subtitle')}</p>
        </div>
      </section>

      <section className="resources-content">
        <div className="container">
          <div className="resources-grid">
            {resources.map((resource) => (
              <div key={resource.id} className="resource-card">
                {resource.image && (
                  <div className="resource-image">
                    <img src={resource.image} alt={resource.title} />
                  </div>
                )}
                <div className="resource-info">
                  <h3>{resource.title}</h3>
                  <a
                    href={resource.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="resource-link"
                  >
                    {t('resources.visitLink')}
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Resources;
